import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ClientsViewProvider } from 'pages/clients/context/clientsPageContext'

const ClientsLayoutContent = () => {
  return <Outlet />
}

export const ClientsPageLayout = observer(() => {
  return (
    <ClientsViewProvider>
      <ClientsLayoutContent />
    </ClientsViewProvider>
  )
})
